import React from 'react';
import { Award, Heart, Users, Sparkles } from 'lucide-react';
import './WhyChoose.css';

const features = [
  {
    icon: Award,
    title: 'Modern Equipment',
    description: 'State-of-the-art technology for precise and comfortable treatments'
  },
  {
    icon: Heart,
    title: 'Painless Dentistry',
    description: 'Advanced techniques ensuring a comfortable and anxiety-free experience'
  },
  {
    icon: Users,
    title: 'Experienced Specialists',
    description: 'Team of skilled professionals with years of expertise'
  },
  {
    icon: Sparkles,
    title: 'Luxury Interiors',
    description: 'Premium ambiance designed for your comfort and relaxation'
  }
];

const WhyChoose = () => {
  return (
    <section id="why-choose" className="why-choose-section section-padding">
      <div className="container">
        <div className="why-choose-header fade-in">
          <h2 className="heading-1">Why Choose Vibe Dental Studio?</h2>
          <div className="section-divider"></div>
          <p className="body-large why-choose-subtitle">
            Experience the difference in modern dental care
          </p>
        </div>

        <div className="why-choose-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="feature-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="feature-icon-wrapper">
                  <Icon size={40} className="feature-icon" />
                </div>
                <h3 className="heading-3">{feature.title}</h3>
                <p className="body-regular">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;